<template>
  <v-card>
    <v-card-title >
      <v-row align="center" class="mt-1" justify="center" >
        Campaña de fondeo
      </v-row>
    </v-card-title>
    <v-card-text class="mt-5"> 
      <v-row align="center" justify="center" style="font-size:24px !important">
        % {{projectInfo.estimatedReturn * 100}} 
      </v-row>
      <v-row align="center" justify="center" class="pt-1">
        Retorno estimado a partir de <b>{{returnDate(projectInfo.profitsBegin)}}</b>
      </v-row>
      <v-row width="100%" class="my-5" align="center" justify="center">
        <progress-display :total-amount="projectInfo.fundingCampaignDTO.creditsAmount" :total-consume="projectInfo.fundingCampaignDTO.creditsFunded" />
      </v-row>
      <v-row align="center" justify="center" class="my-0 py-0">
        Créditos disponibles {{projectInfo.fundingCampaignDTO.creditsAmount-projectInfo.fundingCampaignDTO.creditsFunded }}
      </v-row>
      <v-row align="center" justify="center" class="my-1">
        <v-btn :disabled="projectInfo.status !== 'Published' || projectInfo.fundingCampaignDTO.creditsAmount === projectInfo.fundingCampaignDTO.creditsFunded" @click="invest" color="green">
          Invertir en este proyecto
        </v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  components:{
    ProgressDisplay:()=>import('@/components/ProgressDisplay.vue')
  },
  props:{
    projectInfo: {
      type: Object,
      default: function(){
      }
    }
  },
  computed:{
    ...mapGetters([
      'oidcIsAuthenticated',
      'oidcUser'
    ]),
    ...mapActions([
      'authenticateOidc'
    ]),
    disableInvestment(){
      return (this.projectInfo.fundingCampaignDTO.creditsAmount === this.projectInfo.fundingCampaignDTO.creditsFunded) 
      ||(this.oidcIsAuthenticated &&(this.projectInfo.developer === this.oidcUser.name))
    }
  },
  methods:{
    returnDate(){
      var date= new Date(this.projectInfo.creationDate)
      date.setDate(date.getDate() + (this.projectInfo.profitsBeginQuantity * this.projectInfo.profitsBeginTimePeriod))
      return date.toLocaleDateString('es-AR')
    },
    invest(){
      if(!this.oidcIsAuthenticated){
        this.authenticateOidc
      } else {
        this.$store.dispatch('setInvestmentModal', {
          projectId: this.projectInfo.projectId, 
          creditsAvailable:this.projectInfo.fundingCampaignDTO.creditsAmount - this.projectInfo.fundingCampaignDTO.creditsFunded, 
          creditPrice:this.projectInfo.fundingCampaignDTO.creditPrice
        })
      }
    }
  }
}
</script>
